import React from 'react';
import styles from '../../Payyitme.module.css';

const tiles = [
  {
    title: 'Split with friends',
    desc: 'Share one link for dinners, trips, or gifts — everyone chips in without awkward math.',
    ic: 'yellow',
    icon: <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#161614" strokeWidth="2" strokeLinecap="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>,
  },
  {
    title: 'Freelance & side gigs',
    desc: 'Send one link for deposits, tips, or quick jobs — no invoice required.',
    ic: 'coral',
    icon: <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#FF5A36" strokeWidth="2" strokeLinecap="round"><rect x="2" y="7" width="20" height="14" rx="2" /><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" /></svg>,
  },
  {
    title: 'Small business',
    desc: 'Accept payments on the go with a branded link and built-in chargeback protection on eligible business accounts.',
    ic: 'green',
    icon: <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#2EB66E" strokeWidth="2" strokeLinecap="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" /></svg>,
  },
];

const icClass = { yellow: styles.mtIcYellow, coral: styles.mtIcCoral, green: styles.mtIcGreen };

const UseCases = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.secHeadCenter} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />Use cases</span>
        <h2>One link, lots of ways to use it.</h2>
      </div>
      <div className={styles.methods}>
        {tiles.map((t) => (
          <div key={t.title} className={`${styles.methodTile} ${styles.sr}`} data-sr>
            <div className={`${styles.mtIc} ${icClass[t.ic]}`}>{t.icon}</div>
            <h3>{t.title}</h3>
            <p>{t.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default UseCases;
